import type { RunMetricOutput } from "@/types/RunMetricOutput"
import { formatMetricDisplayName } from "@/utils/formatting/format-metric-display-results"

const YES_NO_UNKNOWN_TITLE: Record<string, string> = {
  YES: "Yes",
  NO: "No",
  UNKNOWN: "N/A",
}

export const SingleString = ({ mo }: { mo: RunMetricOutput }) => {
  const raw = typeof mo.string_value === "string" ? mo.string_value : null
  const displayValue =
    raw && raw in YES_NO_UNKNOWN_TITLE
      ? YES_NO_UNKNOWN_TITLE[raw]
      : raw != null
        ? formatMetricDisplayName(raw)
        : "N/A"
  return (
    <div className="text-2xl text-coval-text font-semibold wrap-break-word overflow-hidden w-full line-clamp-3">
      {displayValue}
    </div>
  )
}
